<div class="filters-container" [ngClass]="{'light-background': lightBackground}" *ngIf="filterConfig">
	<div class="filters-wrapper" [ngClass]="{'adding-filter': addingFilter}">
		<div class="filters">
			<div class="distribute">
				<div class="distribute-filters">
					<div class="search" [hidden]="!filterConfig || !filterConfig.search">
						<ng-container *ngIf="theme !== 'darkTheme'">
							<input type="search" [(ngModel)]="searchValue" (keyup.enter)="doSearch()">
							<i class="fa fa-search" (click)="doSearch()"></i>
						</ng-container>
						<ng-container *ngIf="theme === 'darkTheme'">
							<input type="search" [(ngModel)]="searchValue" (keyup.enter)="doSearch()"
								[placeholder]="('FILTER' | translate) + '...'">
							<i class="fa fa-search" (click)="doSearch()"></i>
						</ng-container>
					</div>
					<bb-filters-controls
						[hidden]="!filterConfig || !filterConfig.filters || !filterConfig.filters.length" [lightBackground]="lightBackground">
					</bb-filters-controls>
				</div>
				<div class="presets" *ngIf="filterConfig?.presets">
					<ng-container *ngFor="let preset of filterConfig?.presets">
						<a (click)="presetClicked(preset)"
							*ngIf="checkedPresets && checkedPresets.includes(preset.id || preset.value) || preset.value === 'all'"
							class="preset" [ngClass]="{'active': isFilterActive(preset)}">
							<div class="icon" *ngIf="!preset?.label" [innerHtml]="preset.value | widgetIcon"></div>
							{{ preset.label }}
						</a>
					</ng-container>

					<div *ngIf="theme !== 'darkTheme'" class="preset" (clickOutside)="setEditing(false)">
						<div (click)="setEditing(!editing)">
							<span>{{ 'PRESETS' | translate }}
								<i class="fa fa-chevron-down"></i>
							</span>
						</div>
						<div class="dropdown" *ngIf="editing">
							<bb-presets-filter-list [filterConfig]="filterConfig"
								[allowCustomPreset]="allowCustomPreset" #checkboxList [storedItems]="checkedPresets">
							</bb-presets-filter-list>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>